__turbopack_context__.v({
  "badgeBest": "SmartSearchPackageCard-module__bPOnnG__badgeBest",
  "badgeEmi": "SmartSearchPackageCard-module__bPOnnG__badgeEmi",
  "badgeSeats": "SmartSearchPackageCard-module__bPOnnG__badgeSeats",
  "body": "SmartSearchPackageCard-module__bPOnnG__body",
  "card": "SmartSearchPackageCard-module__bPOnnG__card",
  "cardImage": "SmartSearchPackageCard-module__bPOnnG__cardImage",
  "cardIncludes": "SmartSearchPackageCard-module__bPOnnG__cardIncludes",
  "cardSubtitle": "SmartSearchPackageCard-module__bPOnnG__cardSubtitle",
  "cardTimer": "SmartSearchPackageCard-module__bPOnnG__cardTimer",
  "cardTitle": "SmartSearchPackageCard-module__bPOnnG__cardTitle",
  "discountTag": "SmartSearchPackageCard-module__bPOnnG__discountTag",
  "duration": "SmartSearchPackageCard-module__bPOnnG__duration",
  "flightSubTextTip": "SmartSearchPackageCard-module__bPOnnG__flightSubTextTip",
  "footer": "SmartSearchPackageCard-module__bPOnnG__footer",
  "footerContent": "SmartSearchPackageCard-module__bPOnnG__footerContent",
  "imageLink": "SmartSearchPackageCard-module__bPOnnG__imageLink",
  "imageWrap": "SmartSearchPackageCard-module__bPOnnG__imageWrap",
  "includeIcon": "SmartSearchPackageCard-module__bPOnnG__includeIcon",
  "inclusion": "SmartSearchPackageCard-module__bPOnnG__inclusion",
  "oldPrice": "SmartSearchPackageCard-module__bPOnnG__oldPrice",
  "perPerson": "SmartSearchPackageCard-module__bPOnnG__perPerson",
  "price": "SmartSearchPackageCard-module__bPOnnG__price",
  "priceBlock": "SmartSearchPackageCard-module__bPOnnG__priceBlock",
  "rating": "SmartSearchPackageCard-module__bPOnnG__rating",
  "soldOutBtn": "SmartSearchPackageCard-module__bPOnnG__soldOutBtn",
  "soldOutCard": "SmartSearchPackageCard-module__bPOnnG__soldOutCard",
  "soldOutImage": "SmartSearchPackageCard-module__bPOnnG__soldOutImage",
  "starting": "SmartSearchPackageCard-module__bPOnnG__starting",
  "titleLink": "SmartSearchPackageCard-module__bPOnnG__titleLink",
  "viewDealsBtn": "SmartSearchPackageCard-module__bPOnnG__viewDealsBtn",
});
